(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["related-products"]) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(related);
    const url = related.dataset.url;
    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.related-products');
        if (recommendations && recommendations.innerHTML.trim().length) {
          related.innerHTML = recommendations.innerHTML;
        }
      })
      .catch((e) => {
        console.error(e);
      });
      };
      const related = document.querySelector('.related-products');

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
          handleIntersection([{ isIntersecting: true }], { unobserve: () => {} });
        });
      } else {
        handleIntersection([{ isIntersecting: true }], { unobserve: () => {} });
      }
    
  } catch(e) { console.error(e); }
})();
})();
